import React from 'react';
// import styles from './SkusFormSection.module.scss';
import AttributesSelector from './AttributesSelector';
import SkusSelector from './SkusSelector';
import { Props } from './types';
import { LabeledFormSectionContainer } from 'components/common';

const SkusFormSection = (props: Props) => {
  const {
    product,
    setProductProp,
    readOnly,
    additionalProps
  } = props;

  return (
    <LabeledFormSectionContainer label='Product SKUs (Stock keeping unit)'>

      <AttributesSelector
        attributes={product.attGroups || []}
        setAttributes={attGroups => !readOnly && setProductProp({ attGroups })}
      />

      <SkusSelector
        skus={product.productSkus || []}
        setSkus={productSkus => !readOnly && setProductProp({ productSkus })}
        additionalProps={additionalProps}
      />

    </LabeledFormSectionContainer>
  );
};

export default SkusFormSection;
